import React from 'react';
import { motion } from 'framer-motion';
const OBJECTIONS = [{
  question: '"No tengo espacio"',
  answer: 'Funciona en patio, terraza, balcón o macetas. El sistema se adapta a cualquier superficie disponible.'
}, {
  question: '"No tengo experiencia"',
  answer: 'Está diseñado para principiantes, con paso a paso real. Empezás desde cero sin conocimientos previos.'
}, {
  question: '"No tengo mucho tiempo"',
  answer: 'El sistema baja tu carga mental y te da rutinas simples. No necesitás horas al día para mantenerlo.'
}, {
  question: '"Ya intenté y me fue mal"',
  answer: 'Justamente: porque te faltaba estructura. Con el sistema, los errores se eliminan antes de que pasen.'
}];
export function ObjectionsSection() {
  return <section className="py-24 px-4 bg-black" data-id="element-110">
      <div className="max-w-4xl mx-auto" data-id="element-111">
        <div className="text-center mb-16" data-id="element-112">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-113">
            ¿Tenés dudas? Las respondemos.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-114">
          {OBJECTIONS.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="bg-zinc-900 border-l-4 border-green-500 border-t border-r border-b border-zinc-800 p-6 rounded-r-xl" data-id="element-115">
              <p className="text-white font-bold text-lg mb-3" data-id="element-116">
                {item.question}
              </p>
              <p className="text-gray-400 leading-relaxed" data-id="element-117">{item.answer}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}